import { Component, input } from '@angular/core';

import { CoreService } from '../core.service';

import { NgClass, NgIf, NgFor, UpperCasePipe, DecimalPipe, TitleCasePipe } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms'

import { AuthConfig, OAuthService } from 'angular-oauth2-oidc';

@Component({
	selector: 'app-auth',
	imports: [
		NgIf,
	],
	templateUrl: './auth.component.html',
	styleUrl: './auth.component.scss'
})
export class AuthComponent {
	constructor(
		public core: CoreService,
		public oauthService: OAuthService
	){ }

	ngOnInit(){
		this.core.auth_component = this;

		if( !this.oauthService.discoveryDocumentLoaded )
			this.oauth_configure();
	}

	//Authorization and Login
	oauth_configure(){
		const authConfig: AuthConfig = {
			// Url of the Identity Provider
			issuer: 'https://accounts.google.com',
			strictDiscoveryDocumentValidation: false,

			redirectUri: `https://beta.bungee.chat/oauth-silent-refresh.html`,
			clientId: '594792101545-v64ffmed7nbdm1kev9eogkcbt8nlf7sr.apps.googleusercontent.com',

			//silentRefreshRedirectUri: `/oauth-silent-refresh.html`,
			//useSilentRefresh: true,

			responseType: 'token id_token',
			scope: 'openid profile email',
			showDebugInformation: true,
		};

		this.oauthService.configure(authConfig);
		this.oauthService.loadDiscoveryDocumentAndTryLogin();
	}
	oauth_login(){
		if( !this.oauthService.discoveryDocumentLoaded ) return;

		this.oauthService.initLoginFlowInPopup()
			.then(() => {
				this.bungee_login()
			}).catch(err => {
				console.error('Login failed:', err);
			});

	}

	should_sign_up = false;
	bungee_login(){
		let idToken = this.oauthService.getIdToken();
		if( !idToken ) return;

		this.core.http.post<any>( `/api/v1/oauth-login`, {
			"idToken": idToken,
		}, { withCredentials: true } ).subscribe( (resp) => {
			console.log(resp);
		}, (err) => {
			if( err.error.code == "user-not-found" ){
				this.should_sign_up = true;
			}
		});
	}

	bungee_signup(){
		let idToken = this.oauthService.getIdToken();
		if( !idToken ) return;

		this.core.http.post<any>( `/api/v1/oauth-signup`, {
			"idToken": idToken, "keep_avatar": true,
		}, { withCredentials: true } ).subscribe( (resp) => {
			console.log(resp);
		}, (err) => {

		});
	}

}
